﻿import {UIText} from "../Tools/Base/UIText";
import {Core} from "../../Base/Core";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";

export class UIQuit extends UICommonPopup {
    Awake() {
        super.Awake();
        this.prompt = this.content.addChild(new UIText(Core.Localizator.Get("quit_message")));
        this.yesBtn = this.content.addChild(new UINineSliceButton("btn-green", { label: Core.Localizator.Get("yes") }));
        this.noBtn = this.content.addChild(new UINineSliceButton("btn-blue", { label: Core.Localizator.Get("no") }));

        this.yesBtn.on("pointertap", () => {
            console.log("QUIT!");
            /*Application.Quit()*/
            this.Hide();
        });
        this.noBtn.on("pointertap", () => this.Hide());
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 0.9;
        let w = Math.min(viewport.width * 0.8, (viewport.height * 0.5) / sideRatio);
        let h = w * sideRatio;

        this.setPopupSize(w, h);

        super.fitLayout(viewport);

        let contentRect = this.getContentSize();

        let rect = contentRect.clone();
        rect.height = contentRect.height * 0.5;
        rect.width = contentRect.width * 0.9;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.2;
        this.prompt.fitLayout(rect);

        rect = contentRect.clone();
        rect.height = contentRect.height * 0.2;
        rect.width = contentRect.width * 0.4;
        rect.x = (contentRect.width - rect.width) * 0.11;
        rect.y = (contentRect.height - rect.height) * 0.87;
        this.yesBtn.fitLayout(rect);

        rect.x = (contentRect.width - rect.width) * 0.89;
        this.noBtn.fitLayout(rect);
    }
}
